module.exports = __webpack_public_path__ + "img/selbsterfahrung_240.f4b81700.png";